import { createTicket } from "./support";

/** Turn an application error into a support ticket (category "bug") so it lands
 *  in the ticketing system, where staff can reply, track, and close it out. */
export async function reportBug(message: string, detail?: string): Promise<{ ticket_id: string }> {
  const subject = `Bug: ${message}`.replace(/\s+/g, " ").trim().slice(0, 195);
  const body = [
    "A user hit an error in the app and reported it.",
    "",
    `Page: ${location.pathname}${location.search}`,
    `Message: ${message}`,
    detail ? `\nStack / details:\n${detail}` : "",
    "",
    `When: ${new Date().toISOString()}`,
    `User agent: ${navigator.userAgent}`,
  ].join("\n").slice(0, 4900);
  return createTicket({ subject, body, category: "bug" });
}
